import { Typography } from '@fox/atoms/src/typography/index';
import { Resizable } from 're-resizable';
import React, { useContext, useState } from 'react';
import { ThemeContext } from 'styled-components';
import { FoxColumnType } from '../../contracts/table';
import { ColumnHeaderComp } from '../components/column-header';
import { ColumnHeader } from '../components/common';
import { useDataGridContext } from '../context';
import type { TableStyleProps } from '../data-grid';
interface DraggableColumnProps<T> {
	column: FoxColumnType<T>;
	columnIndex: number;
	hideColumnBorders?: boolean;
	styles?: TableStyleProps;
}

export const DraggableColumn: React.FC<DraggableColumnProps<Record<string, any>>> = ({ column, columnIndex, hideColumnBorders, styles }) => {
	const { columns, onColumnResized, onColumnOrderChanged } = useDataGridContext();
	const canResizeColumn = !!onColumnResized;
	const allowColumnDrag = !!onColumnOrderChanged;
	const [resizeStarted, setResizeStarted] = useState<number | undefined>(0);
	const theme = useContext(ThemeContext);
	return (
		<Resizable
			handleComponent={{
				right: (
					<div
						style={{
							backgroundColor: theme.colors.grey?.[300],
							opacity: 0,
							height: '100%',
							width: 1
						}}
					/>
				)
			}}
			size={{
				width: column.width,
				height: 60
			}}
			enable={{
				bottom: false,
				top: false,
				left: false,
				right: canResizeColumn,
				bottomLeft: false,
				bottomRight: false,
				topLeft: false,
				topRight: false
			}}
			onResizeStart={() => {
				if (typeof column.width === 'number') setResizeStarted(column.width);
			}}
			onResizeStop={(a, b, _, d) => {
				if (typeof column.width === 'number') {
					const newWidth = resizeStarted + d.width;
					const newColumns = [...columns.filter(c => c.fixed === 'left'), ...columns.filter(c => c.fixed === undefined), ...columns.filter(c => c.fixed === 'right')];
					newColumns[columnIndex + columns.filter(c => c.fixed === 'left')?.length].width = newWidth;
					onColumnResized(newColumns);
				}
				setResizeStarted(undefined);
			}}
			key={column.dataIndex ?? columnIndex}
			lockAspectRatioExtraHeight={30}
			style={{
				width: column.width
			}}
			defaultSize={{
				width: column.width,
				height: 50
			}}
			maxWidth="2048px"
			minWidth="20px"
		>
			<ColumnHeader $hideColumnBorders={hideColumnBorders} $backgroundColor={styles?.headerColour}>
				{column.header ? (
					column.header(column)
				) : (
					<ColumnHeaderComp
						canDrag={allowColumnDrag}
						contents={
							styles ? (
								<Typography variant="h6" component="h5">
									{column.title}
								</Typography>
							) : (
								column.title
							)
						}
					/>
				)}
			</ColumnHeader>
		</Resizable>
	);
};
